import { useSyncExternalStore } from 'react';
import { DEFAULT_ANIMATION, type AnimationConfig } from '@game-platform/pack-animation';
import { resolveOpeningAnimation } from './resolve';
import { loadOpeningAnimation, subscribe } from './store';

/**
 * The mechanic a pack opens with: its own override when it has one, else the
 * operator's global `design_system.animation` (read reactively; the slot lane
 * until the design_system bootstrap resolves).
 */
export function useOpeningAnimation(override?: AnimationConfig | null): AnimationConfig {
  const global = useSyncExternalStore(subscribe, loadOpeningAnimation, () => DEFAULT_ANIMATION);
  return resolveOpeningAnimation(override, global);
}
